/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { connectLoginPopUp } from "../loginPopUp.connect.js";
import { CONFIG, UNICON_THEME } from "../../../config/api.config.js";
import SVG_EyeIcon from "../../../assets/images/svgs/eye.svg?react";
import SVG_EyeOffIcon from "../../../assets/images/svgs/eyeoff.svg?react";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import SVG_UserIcon from "../../../assets/images/svgs/user_2.svg?react";
import SVG_UserWhiteIcon from "../../../assets/images/svgs/user_3.svg?react";
import SVG_MobileIcon from "../../../assets/images/svgs/Mobile2.svg?react";
import SVG_LoadingIcon from "../../../assets/images/svgs/loading.svg?react";
import SVG_GoogleIcon from "../../../assets/images/svgs/google.svg?react";
import SVG_WhatsAppIcon from "../../../assets/images/svgs/whatsAppLogin.svg?react";
import CountryCodeDropdown, {
  mobileFlag,
  mobileLengths,
} from "../CountryCodeDrpodown.jsx";

const LogInStep = ({ onDidDismiss, actions, signUp, logo }) => {
  const [loading, setLoading] = useState(false);
  const [loadingDemo, setLoadingDemo] = useState(false);
  const [showPass, setShowPass] = useState(false);
  // const [openDropdownList, setOpenDropdownList] = useState(false);
  // const [dropdownAnimate, setDropdownAnimate] = useState("");
  const [loginType, setLoginType] = useState("user"); //user or mobile

  const initialValues = {
    countryCode: "91",
    userId: "",
    mobileNum: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    userId:
      loginType == "user"
        ? Yup.string().required("User ID is required")
        : Yup.string().nullable(),
    countryCode:
      loginType == "mobile"
        ? Yup.string().required("Country is required")
        : Yup.string().nullable(),
    mobileNum:
      loginType == "mobile"
        ? Yup.string()
          .matches(/^\d+$/, "Phone Number must only contain digits")
          .when("countryCode", (countryCode, schema) => {
            const length = mobileLengths[countryCode] || 10;
            return schema
              .min(length, `Phone Number must be ${length} digits`)
              .max(length, `Phone Number must be ${length} digits`)
              .required("Phone Number is required");
          })
        : Yup.string().nullable(),
    password: Yup.string()
      .min(5, "Password must be at least 5 characters")
      .required("Password is required"),
  });

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      let data = {
        user_name: loginType == "user" ? values?.userId : values?.mobileNum,
        password: values?.password,
        grant_type: "password",
      };
      await actions.requestAuth(data).then((res) => {
        if (!res?.data?.status) {
          toastr.error("", `${res?.data?.msg}`);
        }
        setLoading(false);
        onDidDismiss();
        const currentTime = new Date()
          .toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
          .replace(",", "");
        localStorage.setItem("lastVisitTime", currentTime);
      });
    } catch (e) {
      setLoading(false);
      toastr.error("", `${e?.msg}`);
    }
  };

  const loginWithDemoId = async () => {
    try {
      setLoadingDemo(true);
      await actions
        .requestAuthDemo()
        .then((res) => {
          if (!res?.data?.status) {
            toastr.error("", `${res?.data?.msg}`);
            return;
          }
          let data = {
            user_name: res?.data?.data?.user_name,
            password: res?.data?.data?.password,
            grant_type: "password",
          };
          actions
            .requestAuth(data)
            .then(() => {
              setLoadingDemo(false);
              onDidDismiss();
              const currentTime = new Date()
                .toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false,
                })
                .replace(",", "");
              localStorage.setItem("lastVisitTime", currentTime);
            })
            .catch((e) => {
              setLoadingDemo(false);
              toastr.error("", `${e.msg}`);
            });
        })
        .catch((e) => {
          setLoadingDemo(false);
          toastr.error("", `${e.msg}`);
        });
    } catch (e) {
      setLoadingDemo(false);
      toastr.error("", `${e.msg}`);
    }

    // actions.requestAuthDemo()
    // requestAuth(response?.data.data)
  };

  const dropdownList = [
    {
      id: "mobile",
      message: "Mobile Number",
      icon: <SVG_MobileIcon fill={"#6B7280"} />,
      activeIcon: <SVG_MobileIcon fill={"var(--color-primary)"} />,
    },
    {
      id: "user",
      message: "User Id",
      icon: <SVG_UserWhiteIcon />,
      activeIcon: <SVG_UserIcon width={16} height={16} />,
    },
  ];

  // const handledropdownOpen = () => {
  //   if (!openDropdownList) {
  //     setDropdownAnimate("popUpOpenAnimation");
  //     setOpenDropdownList(true);
  //   } else {
  //     setDropdownAnimate("popUpCloseAnimation");
  //     setTimeout(() => {
  //       setOpenDropdownList(false);
  //     }, 200);
  //   }
  // };

  const handleLoginType = (value) => {
    // setDropdownAnimate("popUpCloseAnimation");
    setTimeout(() => {
      // setOpenDropdownList(false);
      setLoginType(value);
    }, 200);
  };

  // const OptionDropdown = () => {
  //   return (
  //     <span className=" h-fit">
  //       <div className="w-full h-full relative ">
  //         <div className=" block z-100 h-full">
  //           <div
  //             id="dropdownDefaultButton"
  //             className="w-full cursor-pointer relative hover:undefined font-medium  rounded-r-sm min-h-[35px] text-sm  pr-6 text-center inline-flex items-center bg-bg_BgGray text-text_Quaternary"
  //             onClick={() => {
  //               handledropdownOpen();
  //             }}
  //           >
  //             {loginType == "user" ? <SVG_UserIcon /> : <SVG_MobileIcon />}
  //             <SVG_ChevronDownIcon
  //               className={`w-5 h-5 ms-3 absolute right-1 transform transition-all ease-in-out duration-200 ${
  //                 openDropdownList ? "-rotate-180" : ""
  //               }`}
  //             />
  //           </div>

  //           {openDropdownList && (
  //             <div
  //               id="dropdown"
  //               className={`${dropdownAnimate} bg-bg_Quaternary right-1  origin-top-right top-[102%]  absolute  z-10  divide-y divide-gray-500 rounded-lg shadow w-max  bg-bg_Quaternary text-text_Secondary`}
  //             >
  //               <ul className="py-1 text-sm text-text_Quaternary">
  //                 {dropdownList.map((item, index) => {
  //                   return (
  //                     <li
  //                       key={`${item.id}-dropdown`}
  //                       className={` active:bg-bg_Secondary   ${
  //                         index == 0
  //                           ? "border-b-[1px] pb-1"
  //                           : "text-text_Primary  pt-1"
  //                       }`}
  //                     >
  //                       <button
  //                         type="button"
  //                         className="w-full px-4 py-1 grid grid-cols-4"
  //                         onClick={() => {
  //                           handleLoginType(item.id);
  //                         }}
  //                       >
  //                         <span className=" col-span-1 flex items-center justify-center ">
  //                           {item.id == loginType ? item.activeIcon : item.icon}
  //                         </span>
  //                         <span
  //                           className={` col-span-3 pl-2 font-normal f] font-lato text-start text-red-600  ${
  //                             item.id == loginType
  //                               ? "text-text_Primary"
  //                               : "text-gray-500"
  //                           } `}
  //                         >
  //                           {item?.message}
  //                         </span>
  //                       </button>
  //                     </li>
  //                   );
  //                 })}
  //               </ul>
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     </span>
  //   );
  // };

  const oauth = (provider) => {
    OTPlessSignin.initiate({ channel: "OAUTH", channelType: provider });
    onDidDismiss();
  };

  return (
    <div className="flex gap-10 items-start h-[95%] lg:h-auto w-full">
      <div className=" hidden   lg:w-[50%] rounded-lg overflow-hidden">
        <img
          src={logo}
          alt="register banner"
          style={{
            filter:
              "invert(93%) sepia(83%) saturate(7422%) hue-rotate(-5deg) brightness(91%) contrast(108%)",
          }}
        />
        {/* <img
          src={`/assets/images/${window.location.hostname
            .replace("www.", "")
            .replace("app.", "")}/logo_2.png`}
          alt="register banner"
        /> */}
      </div>
      <div
        title="mobileLogin"
        className="flex flex-col  items-start gap-y-4 w-full "
      >
        <div className="w-full  max-h-[35px] flex items-center justify-between">
          <p className={` ${UNICON_THEME
            ? "text-black"
            : "text-text_color_loginTextColor"}  font-bold text-[22px]`}>
            Sign In
          </p>
          <div className="relative overflow-hidden  max-h-[40px] max-w-[141.428571429px]  flex items-center justify-end">
            <img
              className="md:h-[30px] h-[28px]"
              src={logo}
              alt="register banner"
              style={{
                filter:
                  "hue-rotate(-5deg) brightness(91%) contrast(108%)",
              }}
            />
          </div>
        </div>

        <div className={`w-full cursor-pointer  ${UNICON_THEME == true ? "bg-[rgb(243_244_246/_0.5)] text-black  " : "bg-bg_color_loginTabsBg"} px-2 py-1.5 lg:py-1 rounded-lg flex items-center justify-center gap-2.5 transition-all duration-300 ease-in-out relative`}>
          {dropdownList?.map((items, index) => (
            <div
              onClick={() => {
                handleLoginType(items?.id);
              }}
              key={index}
              style={{
                color: items?.id !== loginType && UNICON_THEME ? "black" : undefined
              }}
              className={` min-w-[45%] text-white cursor-pointer text-[13px] flex items-center justify-center py-2 lg:py-1 md:text-sm lg:text-base font-bold leading-4  rounded-md 
       ${items?.id == loginType
                  ? UNICON_THEME
                    ? "bg-bg_color_LoginBtnBgColor-unicon"
                    : "bg-bg_color_LoginBtnBgColor"
                  : ""
                }
            `}
            >
              {items?.message}
            </div>
          ))}
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values, handleChange, handleBlur, handleSubmit }) => (
            <form
              className="w-full gap-y-4 flex flex-col"
              autoComplete="on"
              onSubmit={handleSubmit}
            >
              <div title="loginFormMonileUserIdInput" className=" w-full ">
                <div className={`text-text_color_loginTextColor font-normal text-sm w-full px-1 pb-1 ${UNICON_THEME?"text-[#6e081d]":"text-white text-transparent"} `}>
                  {loginType == "user" ? "User Id" : "Phone Number"}
                </div>
                <div
                  className={`flex w-full items-center ${loginType == "user" ? "py-2.5" : "py-1"
                    }  bg-bg_BgGray rounded-lg border border-ternary3`}
                >
                  {loginType == "user" ? (
                    <input
                      id="userId-input"
                      className="block focus:outline-none focus:bg-inherit  bg-inherit   w-full px-2 rounded-md font-lato text-text_Ternary  text-sm xs:text-md "
                      placeholder=" USER ID"
                      autoComplete="userName"
                      type="text"
                      name="userId"
                      value={values.userId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  ) : (
                    <>
                      <span
                        id="dropdown-phone-button"
                        className={`flex-shrink-0 z-10 ${UNICON_THEME ? "text-black" : "text-white"}  inline-flex items-center pl-2  text-sm sm:text-md font-lato font-normal text-center`}
                      >
                        +{values.countryCode || "91"}
                        <div className="relative overflow-hidden w-max h-max">
                          <span className="f32">
                            <div
                              className={`flag ${mobileFlag[values.countryCode] || "in"
                                } w-full`}
                            ></div>
                          </span>
                        </div>
                        <CountryCodeDropdown
                          countryType={values.countryCode}
                          handleCountryType={(countryCode) => {
                            handleChange({
                              target: {
                                name: "countryCode",
                                value: countryCode,
                              },
                            });
                          }}
                        />
                      </span>
                      <input
                        id="mobile-no-input"
                        className="block focus:outline-none focus:bg-inherit  bg-inherit   w-full font-lato text-text_Ternary  pr-2 text-sm xs:text-md"
                        placeholder="895XX6XXXX"
                        autoComplete="phoneNo"
                        type="tel"
                        maxLength={mobileLengths[values.countryCode] || 10}
                        name="mobileNum"
                        value={values.mobileNum}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          handleChange({
                            target: {
                              name: "mobileNum",
                              value: onlyNums,
                            },
                          });
                        }}
                        onBlur={handleBlur}
                      />
                    </>
                  )}
                  {/* <OptionDropdown /> */}
                </div>
                {loginType == "user" ? (
                  <ErrorMessage
                    name={"userId"}
                    component="div"
                    className="text-xs  ml-1 text-text_Danger  "
                  />
                ) : (
                  <ErrorMessage
                    name={"mobileNum"}
                    component="div"
                    className="text-xs  ml-1 text-text_Danger  "
                  />
                )}
              </div>

              <div className="flex flex-col gap-1">
                <div title="passwordInput" className=" w-full font-lato ">
                  <div className={`text-text_color_loginTextColor font-normal text-sm w-full px-1 pb-1 ${UNICON_THEME?"text-[#6e081d]":"text-white text-transparent"} `}>
                    Password
                  </div>
                  <div className="flex w-full items-center py-1 px-2 bg-bg_BgGray rounded-lg border">
                    <input
                      id="password-input"
                      className="block focus:outline-none  focus:bg-inherit  bg-inherit   w-full pr-2 rounded-none text-text_Ternary  bg-bg_BgGray text-sm xs:text-md"
                      placeholder="Password"
                      autoComplete="password"
                      type={showPass ? "text" : "password"}
                      name="password"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 16))
                      }
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <span
                      className=" min-h-[30px] flex items-center justify-center"
                      onClick={() => {
                        setShowPass(!showPass);
                      }}
                    >
                      {showPass ? <SVG_EyeOffIcon /> : <SVG_EyeIcon />}
                    </span>
                  </div>
                  <ErrorMessage
                    name={"password"}
                    component="div"
                    className="text-xs  ml-1 text-text_Danger "
                  />
                </div>

                {/* {CONFIG?.showLoginWithOtp && ( */}
                <div
                  title="forgotPassword"
                  className=" w-full  text-end text-xs text-text_color_loginTextColor cursor-pointer  underline font-lato md:text-xs lg:text-sm"
                  onClick={() => actions.setTab(3)}
                >
                  Forgot Password?
                </div>
                {/* )} */}
              </div>
              <div title="loginButton" className=" w-full">
                <button
                  type="submit"
                  disabled={loading}
                  className={` leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full text-text_Quaternary  bg-bg_LoginButtonColorAter ${UNICON_THEME
                    ? "bg-bg_color_LoginBtnBgColor-unicon"
                    : "bg-bg_color_LoginBtnBgColor"} shadow-lg rounded-md xs:text-[15px] px-5 py-2 flex items-center justify-center gap-x-2 font-lato-bold font-semibold text-base cursor-pointer`}
                >
                  Sign In
                  {loading && (
                    <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                      <SVG_LoadingIcon />
                    </span>
                  )}
                </button>
              </div>

              {/* <div
                title="or"
                className=" text-xs text-text_color_loginTextColor   text-center w-full  font-lato lg:text-sm"
              >
                Or Login With
              </div> */}
              <div className="w-full flex items-center gap-4">
                <div className="h-px flex-1 bg-bg_color_quaternary3" />
                <span className="text-text_color_loginTextColor  text-sm font-medium uppercase">
                  OR
                </span>
                <div className="h-px flex-1 bg-bg_color_quaternary3" />
              </div>

              <div
                title="loginWithGoogle"
                className={` ${UNICON_THEME ? "text-black" : "text-white"}  w-full flex items-center justify-between gap-x-2 mb-2`}
              >
                <div className=" w-full flex items-center justify-center cursor-pointer">
                  <button
                    className="inline-block  border-border_color_primary1 leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full font-medium text-[12px] xs:text-[15px] px-5 py-2  flex items-center justify-center gap-x-2 border rounded-lg font-lato-bold lg:text-base  bg-bg_color_primary text-text_color_secondary  cursor-pointer"
                    type="button"
                    onClick={() => oauth("GMAIL")}
                  >
                    <span>
                      <SVG_GoogleIcon />
                    </span>
                    <span>Google</span>
                  </button>
                </div>
                <div className="w-full ">
                  <button
                    className="inline-block  border-border_color_primary1 leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full font-medium text-[12px] xs:text-[15px] px-5 py-2  flex items-center justify-center gap-x-2 border rounded-lg font-lato-bold lg:text-base  bg-bg_color_primary text-text_color_secondary  cursor-pointer"
                    type="button"
                    onClick={() => oauth("WHATSAPP")}
                  >
                    <span>
                      <SVG_WhatsAppIcon />
                    </span>
                    <span>Whatsapp</span>
                  </button>
                </div>
              </div>

              <div title="loginButton" className=" w-full">
                <button
                  type="button"
                  disabled={loadingDemo}
                  className={` leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full text-text_Quaternary  bg-bg_LoginButtonColorAter ${UNICON_THEME
                    ? "bg-bg_color_LoginBtnBgColor-unicon"
                    : "bg-bg_color_LoginBtnBgColor"}  shadow-lg rounded-md xs:text-[15px] px-5 py-2 flex items-center justify-center gap-x-2 font-lato-bold font-semibold text-base cursor-pointer -mt-2`}
                  onClick={() => {
                    loginWithDemoId();
                  }}
                >
                  Login With Demo Id
                  {loadingDemo && (
                    <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                      <SVG_LoadingIcon />
                    </span>
                  )}
                </button>
              </div>
            </form>
          )}
        </Formik>

        {(CONFIG.showSignupOption ||
          (CONFIG.showSignupbyRefer && !!signUp.referCode)) && (
            <div
              title="registerNowButton"
              className=" w-full flex justify-center items-center text-xs md:text-sm lg:text-base"
            >
              <div className={`${UNICON_THEME?"text-black":"text-white"}`}>
                New User?
                <span
                  className={`${UNICON_THEME?"text-[#6e081d]":"text-white text-transparent"}  font-lato-bold font-semibold underline ml-1 cursor-pointer`}
                  onClick={() => {
                    actions.setTab(2);
                  }}
                >
                  Create an account
                </span>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default connectLoginPopUp()(LogInStep);
